<template>
  <div class="bg-filter">
    <br />
    <div class="container" style="padding: 2rem">
      <div class="columns is-multiline center-columns" style="gap: 2rem">
        <div
          class="column is-3 card hover-efx-simple hover-card is-paddingless"
          v-for="(item, i) in data.sections"
          :key="i"
        >
          <div style="margin-bottom: 2rem">
            <div class="card-header has-background-primary-light">
              <p
                class="
                  card-header-title
                  has-text-primary
                  is-bold
                  has-text-centered
                "
                style="justify-content: center"
              >
                <img
                  :src="getImgUrl(item.icon)"
                  :alt="item.name"
                  style="height: 60px; margin: auto 10px"
                />
                {{ item.name | capitalize }}
              </p>
            </div>
            <div class="card-content">
              <p class="has-text-centered">
                {{ item.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
export default {
  name: "Sections",
  props: ["data"],
  data() {
    return {
      title: "Sections",
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/modules/" + pic + ".png");
    },
  },
  filters: {
    capitalize: function (value) {
      let val = value.toLowerCase();
      return val.charAt(0).toUpperCase() + val.substr(1);
    },
  },
};
</script>
